// ─── usePendingAttendanceCount ────────────────────────────────────────────────
// Lightweight hook that polls the pending-request count every 60 s.
// Pass enabled=false (e.g., for non-manager/non-SuperAdmin roles)
// to completely skip network calls.

import { useState, useEffect } from "react";
import { fetchPendingCount } from "../api/attendanceUpdateRequests";

const POLL_INTERVAL_MS = 60_000;

const usePendingAttendanceCount = (enabled: boolean): number => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!enabled) return;

    let cancelled = false;

    const poll = async () => {
      const n = await fetchPendingCount();
      if (!cancelled) setCount(n);
    };

    poll();
    const id = setInterval(poll, POLL_INTERVAL_MS);

    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [enabled]);

  return count;
};

export default usePendingAttendanceCount;
